import React, { useState } from 'react';

import { useReactNativeProps } from '@eika-infrastruktur/mobilbank-lib';
import { runningInRNWebView } from '@eika-infrastruktur/mobilbank-lib/src/nativeHelper';
import { InfoMessage } from '@eika/attention-message';
import { Button } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { Link } from '@eika/link';
import { RadioButtonPanels } from '@eika/radio-button';

import { Content } from '../../components/shared/Content';
import { useConfig } from '../../defaultConfig';
import useTranslation from '../../hooks/useTranslation';
import { isIOS } from '../../utils/native/platform';

import './SwitchLanguage.scss';

const langMap: Record<string, string> = {
    nn: 'nn-no',
    nb: 'nb-no',
};

const SwitchLanguage: React.FC = () => {
    const { siteLang, frontPageLink, appStoreUpdateLink, googlePlayUpdateLink } = useConfig();
    const translated = useTranslation();
    const [selectedLanguage, setSelectedLanguage] = useState<keyof typeof langMap>(siteLang);
    const { supports } = useReactNativeProps();
    const supportsCookies = !runningInRNWebView || !!supports?.cookies;

    const onSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        const newLang = langMap[selectedLanguage] ?? langMap.nb;
        document.location.href = `${frontPageLink?.url}?sc_lang=${newLang}`;
    };

    if (!supportsCookies) {
        return (
            <Content>
                <InfoMessage
                    icon={IconTypes.INFO_20}
                    text={translated.updateToSwitchLanguage}
                    clickableItem={
                        <Link href={isIOS() ? appStoreUpdateLink : googlePlayUpdateLink}>
                            {translated.forceUpdateModal.buttonText}
                        </Link>
                    }
                />
            </Content>
        );
    }

    return (
        <Content>
            <form onSubmit={onSubmit}>
                <RadioButtonPanels
                    className="switch-language__radio-panel"
                    label=""
                    onChange={setSelectedLanguage}
                    selectedOption={selectedLanguage}
                    options={[
                        { value: 'nb', label: 'Bokmål' },
                        { value: 'nn', label: 'Nynorsk' },
                    ]}
                />

                {selectedLanguage !== siteLang && <Button type="submit">{translated.save}</Button>}
            </form>
        </Content>
    );
};

export default SwitchLanguage;
